module.exports = __webpack_public_path__ + "img/etp.16ef2388.svg";